import { Timestamp } from "firebase/firestore";

export type NewBookingSchema = {
    StudentId: string,
    StudentName: string,
    TutorId: string,
    TutorName: string,
    TutorPaymentTier: string,
    SubjectId: string,
    TimeSlotMonday: number,
    TimeSlotTuesday: number,
    TimeSlotWednesday: number,
    TimeSlotThursday: number,
    TimeSlotFriday: number,
    TimeSlotSaturday: number,
    TimeSlotSunday: number,
    TimeZone: string,
    IsRecurring: boolean,
    Duration: number,
    Sessions: number,
    StartDate?: Timestamp,
}

const nameofNewBookingSchemaStudentId = "StudentId";
const nameofNewBookingSchemaStudentName = "StudentName";
const nameofNewBookingSchemaTutorId = "TutorId";
const nameofNewBookingSchemaTutorName = "TutorName";
const nameofNewBookingSchemaTutorPaymentTier = "TutorPaymentTier";
const nameofNewBookingSchemaSubjectId = "SubjectId";
const nameofNewBookingSchemaMondayTimeSlot = "TimeSlotMonday";
const nameofNewBookingSchemaTuesdayTimeSlot = "TimeSlotTuesday";
const nameofNewBookingSchemaWednesdayTimeSlot = "TimeSlotWednesday";
const nameofNewBookingSchemaThursdayTimeSlot = "TimeSlotThursday";
const nameofNewBookingSchemaFridayTimeSlot = "TimeSlotFriday";
const nameofNewBookingSchemaSaturdayTimeSlot = "TimeSlotSaturday";
const nameofNewBookingSchemaSundayTimeSlot = "TimeSlotSunday";
const nameofNewBookingSchemaTimeZone = "TimeZone";
const nameofNewBookingSchemaIsRecurring = "IsRecurring";
const nameofNewBookingSchemaDuration = "Duration";
const nameofNewBookingSchemaSessions = "Sessions";
const nameofNewBookingSchemaStartDate = "StartDate";
const nameofNewBookingSchemaCollection = "NewBooking";

export {
    nameofNewBookingSchemaStudentId,
    nameofNewBookingSchemaStudentName,
    nameofNewBookingSchemaTutorId,
    nameofNewBookingSchemaTutorName,
    nameofNewBookingSchemaTutorPaymentTier,
    nameofNewBookingSchemaSubjectId,
    nameofNewBookingSchemaMondayTimeSlot,
    nameofNewBookingSchemaTuesdayTimeSlot,
    nameofNewBookingSchemaWednesdayTimeSlot,
    nameofNewBookingSchemaThursdayTimeSlot,
    nameofNewBookingSchemaFridayTimeSlot,
    nameofNewBookingSchemaSaturdayTimeSlot,
    nameofNewBookingSchemaSundayTimeSlot,
    nameofNewBookingSchemaTimeZone,
    nameofNewBookingSchemaIsRecurring,
    nameofNewBookingSchemaDuration,
    nameofNewBookingSchemaSessions,
    nameofNewBookingSchemaStartDate,
    nameofNewBookingSchemaCollection,
}

export type NewBookingView = NewBookingSchema & {
    Id: string
}
